import 'bootstrap/dist/css/bootstrap.min.css'
import { FC } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
import { IMultiSelect } from './model'
import { useTranslation } from 'react-i18next'

const animatedComponents = makeAnimated()

const MultiSelect: FC<IMultiSelect> = ({
  setData,
  data,
  editData,
  deleteErrormessage,
  field,
  setPageByScroll,
  dataCount,
  isRtl,
  pageSize = 30
}): JSX.Element => {
  const { t: tGeneral } = useTranslation('general')
  const handleSelectChange = (selectedOptions): void => {
    setData(selectedOptions)
    deleteErrormessage?.(prev => ({ ...prev, [field]: '' }))
  }

  return (
    <Select
      options={data}
      components={animatedComponents}
      isMulti
      onMenuScrollToBottom={() =>
        setPageByScroll?.(prev => {
          const result = Math.ceil(dataCount / pageSize)
          if (result > prev) {
            return prev + 1
          }
          return prev
        })
      }
      onChange={handleSelectChange}
      value={editData}
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        control: base => ({
          ...base,
          direction: isRtl,
          textAlign: isRtl === 'rtl' ? 'right' : 'left'
        }),
        menu: base => ({
          ...base,
          direction: isRtl,
          textAlign: isRtl === 'rtl' ? 'right' : 'left'
        })
      }}
      menuPortalTarget={document.body}
      menuPlacement='auto'
      placeholder={`${tGeneral('select')}`}
      isRtl={isRtl === 'rtl'}
    />
  )
}

export default MultiSelect
